<template>
    <div class="inputTel">
        <div class='hong'>
            <div class='hong_content'>
                <h2>品质选择，值得信赖</h2>
                <div class='tel'>
                    <img src='../assets/phone.png' />
                    <el-input placeholder='请输入手机号码' v-model='tel'></el-input>
                    <div class='line'></div>
                    <div class='but' @click="getFreeTrial">免费体验</div>
                </div>
                <div class='home_tick'>
                    <div>
                        <img src='../assets/tick.png' />
                        免费上门或线上产品演示
                    </div>
                    <div>
                        <img src='../assets/tick.png' />
                        专业客户顾问全程服务
                    </div>
                    <div>
                        <img src='../assets/tick.png' />
                        企业定制化解决方案
                    </div>
                    <div>
                        <img src='../assets/tick.png' />
                        全天候业务咨询服务
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// export function postAction(url, parameter) {
//     return axios({
//         url: url,
//         method: 'post',
//         data: parameter,
//     })
// }
import axios from 'axios'
export function uploadAction(url,parameter){
    return axios({
        url: url,
        data: parameter,
        method:'post' ,
        headers: {
            'Content-Type': 'multipart/form-data',  // 文件上传
        },
    })
}
export default {
    name: 'inputTel',
    data() {
        return {
            tel: '',
        }
    },
    mounted() {

    },
    methods:{
        getFreeTrial() {
            let url = "https://iboran.com/api.php/cms/addform"
            let params = {
                fcode: 3,
                tel: this.tel
            }
            uploadAction(url, params).then(res => {
                // console.log(res, 'rrrrrrrrrrrrrr-----------ssssssss')
                alert(res.data.data)
            }).catch(err => {
                alert(err.message)
            })
        }


    }
}
</script>

<style lang="scss" scoped>
    .inputTel{
        width: 100%s;
        .hong{
            background: url(../assets/hong.png) #fff no-repeat center center;
            background-size: auto 321px !important;
            .hong_content{
                margin: 0 auto;
                >h2{
                    font-size: 30px;
                    font-weight: bold;
                    line-height: 26px;
                    letter-spacing: 2px;
                    color: #ffffff;
                    padding-top: 70px;
                    text-align: center;
                    padding-bottom: 46px;
                }
                .tel{
                    height: 50px;
                    align-items: center;
                    margin: 0 auto;
                    background-color: #ffffff;
                    border-radius: 6px;
                    border: solid 1px #fdddd3;
                    display: flex;
                    >img{
                        width: 18px;
                        height: 20px;
                        margin-left: 23px;
                        margin-right: 9px;
                    }
                    .line{
                        width: 1px;
                        height: 20px;
                        background-color: #e5e5e5;
                    }
                    /deep/ .el-input{
                        flex: 1!important;
                    }
                    /deep/ .el-input__inner{
                        border-style: none!important;
                        background: none!important;
                        line-height: 38px!important;
                        font-size: 16px!important;
                        color: #b3b3b3!important;
                        border-width: 0!important;
                        border-color: white!important;
                    }
                    .but{
                        font-size: 18px;
                        font-weight: bold;
                        line-height: 26px;
                        letter-spacing: 1px;
                        color: #e50b18;
                        margin-left: 35px;
                        margin-right: 30px;
                        cursor: pointer;
                    }
                    .but:hover{
                        color: rgb(225, 115, 45)
                    }
                }
                .home_tick{
                    margin: 38px auto;
                    // display: flex;
                    >div{
                        float: left;
                        font-size: 16px;
                        line-height: 26px;
                        letter-spacing: 1px;
                        color: #fff1f2;
                        padding-right: 20px;
                        >img{
                            vertical-align: middle;
                            margin-right: 8px;
                        }
                    }
                    >div:last-of-type{
                        padding-right: 0;
                    }
                }
            }
        }
    }
</style>
<style scoped>
@media all and (min-width: 980px) {
    .footer2{
        display: none !important;
    }
    .footer1{
        display: block !important;
    }

    .inputTel .hong .hong_content{
        width: 75rem;
    }
    .inputTel .hong .hong_content .tel{
        width: 900px;
    }
    .inputTel .hong .hong_content .home_tick{
        width: 838px;
    }
    .inputTel .hong{
        height: 321px;
    }

}
@media all and (max-width: 980px) {

    .inputTel .hong .hong_content{
        width: 100% !important;
    }
    .inputTel .hong .hong_content .tel{
        width: 90% !important;
    }
    .inputTel .hong .hong_content .home_tick{
        width: 90% !important;
    }
    .inputTel .hong{
        height: 360px;
    }

}

</style>



// WEBPACK FOOTER //
// src/components/inputTel.vue